/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST,
  DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_SUCCESS,
  DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_FAILURE,
  DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST,
  DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST_SUCCESS,
  DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST_FAILURE,
  FETCH_TAX_AUTHORIXATION_YEARS_REQUEST,
  FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_SUCCESS,
  FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_FAILURE,
  SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST,
  SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_SUCCESS,
  SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_FAILURE,
  CLEAN_DOCUMENT_SIGNATURE_COORDINATES_PROPS,
  CLEAN_DOCUMENT_ERROR_IN_SIGNTAURE_UPLOAD,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  years: [],
  yearsLoading: false,
  yearsErrors: {},
  singleTaxAuthorization: [],
  singleTaxAuthorizationLoading: false,
  singleTaxAuthorizationErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const signatureReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST:
    case DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_FAILURE:
    case DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case FETCH_TAX_AUTHORIXATION_YEARS_REQUEST:
      return Object.assign({}, state, {
        yearsLoading: true,
      });

    case FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        yearsLoading: false,
        years: action.data,
        yearsErrors: {},
      });

    case FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        yearsLoading: false,
        yearsErrors: action.error,
      });

    case SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleTaxAuthorizationLoading: true,
      });

    case SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleTaxAuthorizationLoading: false,
        singleTaxAuthorization: action.data,
        singleTaxAuthorizationErrors: {},
      });

    case SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleTaxAuthorizationLoading: false,
        singleTaxAuthorizationErrors: action.error,
      });

    case CLEAN_DOCUMENT_SIGNATURE_COORDINATES_PROPS:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
        years: [],
        yearsLoading: false,
        yearsErrors: {},
        singleTaxAuthorization: [],
        singleTaxAuthorizationLoading: false,
        singleTaxAuthorizationErrors: {},
      });

    case CLEAN_DOCUMENT_ERROR_IN_SIGNTAURE_UPLOAD:
      return Object.assign({}, state, {
        errors: {},
        yearsErrors: {},
        singleTaxAuthorizationErrors: {},
      });

    default:
      return state;
  }
};

export default signatureReducer;
